import { Action, createReducer, on } from '@ngrx/store';
// import {DoctorStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import { editDoctor, loadDoctors, paginateDoctors, removeAllDoctors, removeDoctors } from 'src/actions/user/doctor.action';

export const initialState: any = {
  fetching: false,
  data: {
    doctors: [],
    totalDocuments: 0
  }
};

const doctorsReducer = createReducer(initialState,
  on(loadDoctors, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctors: [
          ...state.data.doctors,
          ...payload.filter(p => !state.data.doctors.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editDoctor, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        doctors: state.data.doctors.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeDoctors, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctors: state.data.doctors
          .filter((d: any) => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllDoctors, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        doctors: [],
        totalDocuments: 0
      }
    }
  )
  ),
  on(paginateDoctors, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return doctorsReducer(state, action);
}
